import { render, staticRenderFns } from "./Garland.vue?vue&type=template&id=32696b88&lang=pug&"
import script from "./Garland.vue?vue&type=script&lang=ts&"
export * from "./Garland.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports